module.exports = __webpack_public_path__ + "static/img/ikonaScratch-OFF.f4683de0.png";